// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"e79550fa","130":"026fc1ef","149":"65f091cf","156":"f699d5ca","181":"30f6b000","283":"143ed738","372":"c5aa88d6","378":"921612e3","408":"dc9c5e53","437":"16f96d35","596":"49c5979a","789":"309cd080","839":"0bfc8a87","942":"ff2560f8"}[chunkId] + ".chunk.js";
};